module.exports = __webpack_public_path__ + "img/7.efba2c5b.png";